import { useCallback } from "react";
import { graphql, useStaticQuery } from "gatsby";

const useReevooTrack = (productId) => {
  const {
    config: { isReevooActiveFieldSet },
    labelManagerLabels,
  } = useStaticQuery(graphql`
    {
      config: liferayGeneralConfiguration {
        isReevooActiveFieldSet {
          isReevooActive
          reevooAccountCode
        }
      }
      labelManagerLabels: labelManagerLabels {
        whereToBuy
      }
    }
  `);
  const reevooTrack = useCallback(() => {
    if (
      typeof window !== "undefined" &&
      isReevooActiveFieldSet &&
      !!isReevooActiveFieldSet.isReevooActive?.length
    ) {
      if (window.reevooMark) {
        window.reevooMark("trackPropensityToBuy", isReevooActiveFieldSet.reevooAccountCode, {
          sku: productId,
          cta: labelManagerLabels.whereToBuy,
        });
      }
    }
  }, [productId, labelManagerLabels, isReevooActiveFieldSet]);

  return reevooTrack;
};

export default useReevooTrack;
